import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  excerpt: string;
  date: string;
  readTime: number;
  tags: string[];
  featured?: boolean;
}

export default function ArticleCard({
  title,
  slug,
  category,
  categorySlug,
  thumbnail,
  excerpt,
  date,
  readTime,
  tags,
  featured,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="relative block overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 里番动漫推荐`}
          className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {featured && (
          <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2 py-1 rounded-md whitespace-nowrap">
            精选
          </span>
        )}
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs text-primary-600 bg-primary-100/70 px-2 py-0.5 rounded-md hover:bg-primary-200 transition-colors whitespace-nowrap"
          >
            {category}
          </Link>
        </div>
        <Link to={`/article/${slug}`} className="group/link">
          <h3 className="text-base font-semibold font-heading text-foreground-950 group-hover/link:text-primary-500 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed flex-1">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400 mt-auto">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            {readTime} 分钟阅读
          </span>
        </div>
        {tags.length > 0 && (
          <div className="flex items-center gap-1.5 mt-3 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-xs text-secondary-700 bg-secondary-100/80 px-1.5 py-0.5 rounded whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}